var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.validSettings)?_c('span',[_vm._v(_vm._s(_vm.internalLatitude)+"; "+_vm._s(_vm.internalLongitude))]):_c('span',[_vm._v("Not set")])}
var staticRenderFns = []

export { render, staticRenderFns }